import React from 'react'
import { Link } from 'react-router-dom'
import './Caret.css'

const CaretUI = ({ className, direction, location, to }) =>
  <Link to={to} className={`w_caret ${className ? className : ''}
    ${location === 'row' ? 'row' : (location === 'title' ? 'title' : '')}`}>
    <span className={`icon ${direction === 'left' ? 'icon-caret-left' : 'icon-caret-right'}`} />
  </Link>
export default CaretUI
